import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar24Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar24 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar24Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar24">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.855 0 151.834-67.978 151.834-151.834C303.667 67.978 235.688 0 151.833 0S0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="Vector"
            d="M235.614 276.293c-12.042-9.85-61.634-27.715-90.095-32.64-28.47-4.925-84.48 6.109-95.975 10.486-1.914.731-3.916 2.208-5.941 4.17 27.54 27.993 65.852 45.358 108.231 45.358 31.544 0 60.847-9.628 85.123-26.095a14.555 14.555 0 0 0-1.343-1.279Z"
            fill="#000"
          />
          <G id="Group_2">
            <Path
              id="skin"
              d="M238.506 164.464c2.233-11.868.588-14.156.588-29.447 1.915-41.442-17.706-79.602-45.167-79.602-75.813 0-83.4 19.779-83.4 66.074 0 2.407 2.908 4.202 3.138 6.697-7.189 0-9.675 13.083-6.529 22.353 7.379 21.741 18.977 19.064 19.326 18.882 2.868 6.402.763 43.324-.325 50.807-2.884 19.771-13.393 23.743-13.393 23.743s27.198 12.209 80.158 53.492c6.172-10.009-.699-37.597-8.333-41.116-5.87-1.136 4.203-30.567 4.957-43.253 10.232-1.461 23.537 7.96 29.868-6.72 3.71-8.595 16.364-27.318 19.112-41.918v.008Z"
              fill={c.skin}
            />
            <Path
              id="Vector_2"
              opacity={0.75}
              d="M143.612 194.157c0 .366 2.28 17.706 24.157 33.323 9.246 6.602 10.583 7.817 17.295 9.724.993-5.751 4.462-24.109 4.462-24.109-.358.039-27.993-5.37-45.914-18.938Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_3"
              opacity={0.75}
              d="M203.109 165.48c-.54 2.368 2.074 3.933 11.034 3.535 7.38-.325 9.763-4.813 8.309-5.441-1.446-.628-3.392 2.192-8.198 2.192-7.006 0-10.604-2.645-11.145-.278v-.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_4"
              opacity={0.75}
              d="M188.343 180.112c.715.811 12.241 14.029 23.886 14.029 9.914 0 11.852-10.438 12.114-11.026-3.114 1.263-5.68 4.838-11.478 4.838-12.472 0-21.003-5.354-24.522-7.841Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_5"
              opacity={0.75}
              d="M217.113 178.239c-3.05 0-4.027 1.422-4.027 1.422s-3.876-1.74-7.117-1.74-6.188 1.581-9.239 1.978c-3.082.397-8.404-.095-8.404-.095s-.024.285 0 .309c3.519 2.074 11.812 3.631 24.284 3.631 5.798 0 8.594-.08 11.708-1.128l.016-.032s-4.186-4.345-7.236-4.345h.015Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_6"
              d="M154.765 120.909c-.111.072-.048.247.087.231 2.439-.302 14.752-1.533 23.45-1.374 11.645.214 19.033 8.698 22.123 3.709 1.477-2.391.127-7.014-21.13-9.198-9.35-.962-16.237 1.056-24.53 6.64v-.008Z"
              fill="#000"
            />
            <Path
              id="Vector_7"
              d="M197.183 140.395c-2.733-4.257-5.95-6.942-9.302-8.571-2.041-.993-4.139-1.596-6.188-1.922-6.458-1.025-12.551.651-15.696 1.366-.993.23-1.303 1.652-.541 2.486l2.153 2.352c.342.373.81.524 1.239.397 1.43-.413 4.782-1.136 8.754-1.748a7.044 7.044 0 0 0 .04 2.479c.707 3.487 3.9 5.783 7.133 5.131 2.86-.58 4.79-3.272 4.711-6.299 3.122 1.501 6.045 3.519 7.332 4.742.238.223.532-.119.349-.397l.016-.016Z"
              fill="#000"
            />
            <Path
              id="Vector_8"
              d="M218.107 123.92c.874 1.295 3.344 3.487 5.33 2.025 2.931-3.058 7.253-5.473 14.108-5.655a169.9 169.9 0 0 0-.23-4.473c-16.285.151-20.4 6.347-19.208 8.111v-.008Z"
              fill="#000"
            />
            <Path
              id="Vector_9"
              d="M219.409 138.091a20.798 20.798 0 0 0-2.263 3.63c-.128.262.254.493.452.27.541-.603 1.462-1.437 2.598-2.335 1.247 1.732 3.551 2.915 6.22 2.915 3.98 0 7.212-2.597 7.212-5.806 0-1.017-.357-1.963-.929-2.797 3.678.326 5.481 1.676 7.769 1.645.024-1.565.024-3.146.016-4.719-3.63.191-7.809-1.167-11.757.397-3.471 1.375-6.76 3.504-9.318 6.808v-.008Z"
              fill="#000"
            />
            <Path
              id="hair"
              d="M240.539 147.306c.564-7.07 5.68-12.138 9.342-18.159 8.086-12.885 4.504-23.958-.334-37.025-2.613-22.179-24.029-24.474-24.029-24.474s-4.012-11.344-22.989-23.926c-18.969-12.583-49.321-11.288-53.5-5.87-55.112-1.407-67.004 45.603-68.576 77.298l-.421-.619s-45.144 17.475-32.53 61.912c8.921 31.425 25.42 57.074-4.948 54.509 0 0 15.935 16.252 36.048 8.833 13.63-5.029 19.97-18.834 19.97-18.834l-2.852 12.272s19.97-12.55 17.118-27.675c-2.851-15.125-12.55-21.4-9.985-33.101a204.944 204.944 0 0 1 1.637-6.903c11.574 10.835 23.608 17.841 23.608 17.841l-.667-13.678c-27.803-11.272-23.291-40.759-12.774-40.759 10.518 0 16.531 12.4 16.531 12.4l7.483-1.557c.238 3.988 1.247 7.904 3.432 11.614 1.938 3.535 5.489 6.776 7.347 9.754 2.487 3.853 2.566 8.881 1.533 13.306-1.167 5.155-4.591 9.334-6.227 14.624-1.78 5.632-.691 12.011 2.279 16.912 1.367 2.399 2.765 4.52 3.114 6.887.342 2.303-.119 5.076-1.302 7.078-1.009 1.811-3.289 2.271-4.314 4.17-1.43 3.36.08 7.197 1.581 10.136 1.287 2.391 2.884 4.591 4.695 6.577-3.082-4.083-6.141-9.175-5.648-14.401.151-1.256.651-2.153 1.771-2.781 5.521-2.589 6.808-10.128 4.457-15.307-.549-1.319-1.184-2.534-1.74-3.71-2.256-4.488-2.788-9.611-.985-14.219 1.978-4.837 5.862-9.135 7.451-14.489 1.35-4.361 1.851-9 .81-13.52-.858-4.273-4.154-8.507-6.315-11.597-4.274-6.117-4.059-11.995-2.629-18.151.405-.707.866-1.39 1.374-2.002 3.273-.572 6.498-1.446 9.659-2.526 8.135-2.995 16.571-7.435 22.219-14.553 6.648-8.833 9.579-20.383 9.293-31.615 2.971-2.407 6.443-4.504 9.962-5.624-3.948-14.465-21.599-22.917-21.599-22.917s6.76 2.256 12.4 6.196c5.632 3.948 9.953 12.582 13.528 18.032 8.825 0 20.471 9.953 20.661 17.658.191 7.705 9.016 12.583 12.583 18.032 2.947 4.496.778 17.666-.072 22.147-1.414 2.788-2.558 5.735-2.971 9.024-1.954 18.389 14.45 16.713 13.369 34.34-.27 4.241-1.501 8.293-3.36 12.169-2.391 5.33-6.315 10.486-6.315 16.658.127 6.085 3.456 11.637 7.912 15.537-4.067-4.059-6.998-9.715-6.72-15.513.429-5.863 4.559-10.486 7.252-15.586 4.512-7.8 6.848-18.476 2.209-26.96-3.543-6.379-9.763-10.065-8.826-17.873v.008Zm-52.467-63.144c-3.424 11.4-7.697 22.806-16.515 30.027-4.019 3.225-8.245 5.989-12.638 8.42 4.615-4.575 11.661-9.699 14.855-14.092 5.695-7.848 11.939-22.075 14.306-24.355h-.008Z"
              fill={c.hair}
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};
